import { useRows } from '@terminal/components/chat';
import clsx from 'clsx';
import { ReactNode, TextareaHTMLAttributes, useState } from 'react';

import styles from './QuestionViewTextArea.module.scss';

export interface QuestionViewTextAreaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
  errorText?: ReactNode;
}

export const QuestionViewTextArea = ({
  hasError,
  errorText,
  ...rest
}: QuestionViewTextAreaProps) => {
  const [focused, setFocused] = useState(false);

  const onFocus = () => {
    setFocused(true);
  };

  const onBlur = () => {
    setFocused(false);
  };

  const { value, onChange } = rest;
  const { rows, updateRows } = useRows({ value });

  return (
    <div className={styles.questionViewContainer}>
      <div
        data-testid="input-wrapper"
        className={clsx(styles.inputWrapper, {
          [styles.error]: hasError,
          [styles.focused]: focused,
        })}
      >
        <textarea
          className={styles.textAreaElement}
          onFocus={onFocus}
          onBlur={onBlur}
          rows={rows}
          data-testid="textarea-input"
          {...rest}
          onChange={e => {
            updateRows(e);
            onChange?.(e);
          }}
          value={value}
        />
      </div>
      {hasError && errorText && (
        <label data-testid="error-text" className={styles.errorLabel}>
          {errorText}
        </label>
      )}
    </div>
  );
};
